import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    dam: [],
  },
  submitted: 0,
};

const PipelinefilterSlice = createSlice({
  name: "pipelinefilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const { addFilters, applyFilters, chgSubmitted, resetFilters } =
  PipelinefilterSlice.actions;

export default PipelinefilterSlice.reducer;
